'use client'

import { useCallback, useEffect } from 'react'
import { useClientApi } from '@/setup/api-client'

type IWafCaptchaTestWindow = { __wafCaptchaTest?: () => Promise<unknown> }

/**
 * Exposes the temporary non-production WAF CAPTCHA test action for account-menu use.
 */
export function useWafCaptchaTestAction() {
    const api = useClientApi()
    const enabled = process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production'
    const trigger = useCallback(() => api.get('/health', { captcha_test: '1' }), [api])

    useEffect(() => {
        if (!enabled) return
        ;(window as unknown as IWafCaptchaTestWindow).__wafCaptchaTest = trigger
        return () => {
            delete (window as unknown as IWafCaptchaTestWindow).__wafCaptchaTest
        }
    }, [enabled, trigger])

    return { enabled, trigger }
}
